/**
 * @generated SignedSource<<86dea30c004aa99108f33bf9e5707546>>
 * @relayHash ceaacc65dbf21edd354b2ad6f80fec37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f8294f49f3cbb11e094270ce1b31e31e0c6bc64f8a18a440b1a58853879c1c60

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { AutomaticTeamAssignmentRowPreloadedQuery } from './AutomaticTeamAssignmentRowPreloadedQuery.graphql';

const node: PreloadableConcreteRequest<AutomaticTeamAssignmentRowPreloadedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f8294f49f3cbb11e094270ce1b31e31e0c6bc64f8a18a440b1a58853879c1c60",
    "metadata": {},
    "name": "AutomaticTeamAssignmentRowPreloadedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
